import { render, staticRenderFns } from "./videojs.vue?vue&type=template&id=4d206a8d&scoped=true"
import script from "./videojs.vue?vue&type=script&lang=js"
export * from "./videojs.vue?vue&type=script&lang=js"
import style0 from "./videojs.vue?vue&type=style&index=0&id=4d206a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d206a8d",
  null
  
)

export default component.exports